<template>
  <cms-hero-standard v-bind="$props" />
</template>

<script lang="ts" setup>
import type { HeroContent } from '#types/components/cms/hero'

defineProps<{
  content: HeroContent
  paused?: boolean
  firstElement?: boolean
}>()
</script>
